import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer } from '@angular/platform-browser';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { UserProfileService } from 'services';

@Component({
    selector: 'app-avatar',
    imports: [MatToolbarModule, MatMenuModule, MatIconModule, MatButtonModule],
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    standalone: true,
})
export class AvatarComponent {
  // Inject dependencies
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly userProfileService = inject(UserProfileService);
  private readonly oidcSecurityService = inject(OidcSecurityService);

  // Convert Observable to signal
  readonly user = toSignal(this.userProfileService.user$);

  sanitizeUrl(url: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + url);
  }

  async logout(): Promise<void> {
    await firstValueFrom(this.oidcSecurityService.logoffAndRevokeTokens());
  }
}
